export default "__VITE_ASSET__Dq__VVKI__"